import { memo, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const Iframe = ({ content = undefined, onLoad = undefined }) => {
  const iframeRef = useRef(),
        timeoutRef = useRef()

  const setStyles = useCallback(() => {
    if(iframeRef.current?.style) {
      iframeRef.current.style.minWidth = '100%';
      iframeRef.current.style.width = `${iframeRef.current.contentWindow.document.body.scrollWidth}px`; // 32 for standard margins
      iframeRef.current.style.height = `${iframeRef.current.contentWindow.document.body.scrollHeight + 32}px`; // 32 for standard margins
    } else {
      timeoutRef.current = setTimeout(setStyles, 500)    
    }
  }, [])
  const writeHTML = useCallback(() => {
    if (!iframeRef.current) {
      return;
    }
    timeoutRef.current = setTimeout(setStyles, 1000);
  }, [setStyles]);

  useEffect(() => {
    writeHTML()
  }, [writeHTML])

  useEffect(() => () => {
    clearTimeout(timeoutRef.current)
  }, [])

  return (
    <iframe
        onLoad={() => {
          setStyles()
          onLoad?.()
        }}
        ref={iframeRef}
        srcDoc={`<style>html,body{overflow:hidden}</style>${content}`}
        style={{ 
          border: 'none',
          height: '100%',
          overflow: 'hidden',
        }}
    />
  )
}

Iframe.propTypes = {
  content: PropTypes.string,
  onLoad: PropTypes.func
}

export default memo(Iframe);
